<template>
    <div class="container">
        <div class="row">
            <div class="col-12" style="min-height: 500px; margin-top: 100px">
              <!-- <Spinner></Spinner> -->
              <RegionToggles></RegionToggles>
              
            </div>
        </div>
    </div>
</template>

<script>
import Spinner from "@/components/common/Spinner"
import RegionToggles from "@/components/search/RegionToggles";

export default {
    name: "DevView",
    components: {
      Spinner,
      RegionToggles
    },
    computed: {
      
    }
}
</script>